// extracted by mini-css-extract-plugin
export var Content = "Resources-module--Content--1UZIB";
export var Schema = "Resources-module--Schema--2NVMG";
export var Endpoint = "Resources-module--Endpoint--1SOAG";
export var Description = "Resources-module--Description--2CzJ_";
export var Structure = "Resources-module--Structure--EpTvB";
export var Verb = "Resources-module--Verb--1oHPX";
export var Url = "Resources-module--Url--26kVL";